import { render, staticRenderFns } from "./examResult.vue?vue&type=template&id=0c0c143e&scoped=true"
import script from "./examResult.vue?vue&type=script&lang=js"
export * from "./examResult.vue?vue&type=script&lang=js"
import style0 from "./examResult.vue?vue&type=style&index=0&id=0c0c143e&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0c0c143e",
  null
  
)

export default component.exports